(function () {
    'use strict';

    angular
        .module('spidwebApp')
        .controller('WeightController', WeightController);

    WeightController.$inject = ['$scope', '$uibModalInstance', '$timeout', 'productNatureService', 'productCardDto', 'model', 'productNature', 'userSettings', 'articles', 'modelService', 'isCreaManu'];

    function WeightController($scope, $uibModalInstance, $timeout, productNatureService, productCardDto, model, productNature, userSettings, articles, modelService, isCreaManu) {

        model.articles = model.items;
        model.articles.forEach(function (article) {
            initWeight(article);
        });

        $scope.floatTheadDimensionsOptions = {
            top: 85,
            position: 'auto',
            autoReflow: true,
            scrollContainer: true
        };


        function initModel() {
            if (!model.capacityValue || !model.capacityUnit) {
                model.capacityUnit = null;
                model.capacityValue = null;
            }
            if (!_(model.articles).isEmpty()) {
                var allArticlesSelected = _(model.articles).filter(function (article) {
                    return !!article.balisage;
                });
                if (!allArticlesSelected || !_(allArticlesSelected).isEmpty()) {
                    model.defaultSignKitArticleId = _(allArticlesSelected).first().code;
                }
            }
        }

        initModel();

        $scope = _($scope).extend({
            productCardDto: productCardDto,
            model: model,
            productNature: productNature,
            dimensionType: productNatureService.getProductNatureType(productNature),
            checkDisabledState: checkDisabledState,
            isAdmin: isAdmin,
            close: close,
            submit: submit,
            needsSizeGridUpdate: false,
            sizeGridLoading: false,
            sizeGridResult: null,
            updateSizeGrid: updateSizeGrid,
            // Article sync
            needsSync: false,
            savedItemsCount: (model.items || []).length,
            mdItemsCount: (articles || []).length,
            syncLoading: false,
            syncResult: null,
            syncMissingArticles: syncMissingArticles,
            isCreaManu: isCreaManu
        });

        function buildFeedbackResult(status, prefix) {
            var map = {
                success: {
                    cssClass: 'text-success',
                    icon: 'glyphicon-ok',
                    label: prefix + '.success',
                    tooltip: prefix + '.tooltip.success'
                }, uptodate: {
                    cssClass: 'text-info',
                    icon: 'glyphicon-info-sign',
                    label: prefix + '.uptodate',
                    tooltip: prefix + '.tooltip.uptodate'
                }, error: {
                    cssClass: 'text-danger',
                    icon: 'glyphicon-warning-sign',
                    label: prefix + '.error',
                    tooltip: prefix + '.tooltip.error'
                }
            };
            return map[status] || null;
        }

        var mdArticles = articles || [];

        $scope.needsSync = mdArticles.length > model.items.length;
        $scope.missingCount = mdArticles.length - model.items.length;
        $scope.needsSizeGridUpdate = computeNeedsSizeGridUpdate(mdArticles);

        // Show "already up to date" immediately when masterdata confirms no update is needed.
        if (!$scope.needsSizeGridUpdate) {
            $scope.sizeGridResult = buildFeedbackResult('uptodate', 'product.sizeGrid');
        }

        function syncMissingArticles() {
            if (!isCreaManu) {
                return;
            }

            $scope.syncLoading = true;
            $scope.syncResult = null;
            modelService.insertMissingArticles(model.code)
                .then(function () {
                    // Add missing articles from masterdata into model.items
                    _(mdArticles)
                        .chain()
                        .reject(function (mdArticle) {
                            return _(model.items).findWhere({code: String(mdArticle.articleId)});
                        })
                        .each(function (mdArticle) {
                            model.items.push({code: String(mdArticle.articleId), size: mdArticle.articleSizeValue});
                        })
                        .value();

                    $scope.syncResult = 'success';
                    $scope.needsSync = false;
                })
                .catch(function () {
                    $scope.syncResult = 'error';
                })
                .finally(function () {
                    $scope.syncLoading = false;
                    $scope.$apply();
                });
        }

        function computeNeedsSizeGridUpdate(articlesFromMD) {
            if (!articlesFromMD || articlesFromMD.length === 0 || articlesFromMD.every(function (a) {
                return !a.fmsGridId;
            })) {
                return false;
            }

            let gridIdMismatch = articlesFromMD.some(function (mdArticle) {
                return String(mdArticle.fmsGridId) !== String(model.gridSize);
            });
            let sizeValueMismatch = model.items.some(function (item) {
                const mdArticle = _(articlesFromMD).findWhere({articleId: item.code});
                return !mdArticle || mdArticle.articleSizeValue !== item.size;
            });
            return gridIdMismatch || sizeValueMismatch;
        }

        function updateSizeGrid() {
            $scope.sizeGridLoading = true;
            $scope.sizeGridResult = null;
            modelService.updateSizeGrid(model.code)
                .then(function (data) {
                    $timeout(function () {
                        $scope.sizeGridResult = buildFeedbackResult((data && data.length > 0) ? 'success' : 'uptodate', 'product.sizeGrid');
                        $scope.needsSizeGridUpdate = false;
                        model.gridSize = _.first(articles).fmsGridId;
                        model.items.forEach(function (item) {
                            item.size = _.result(_(articles).findWhere({articleId: item.code}), 'articleSizeValue') || item.size;
                        });
                    });
                })
                .catch(function () {
                    $timeout(function () {
                        $scope.sizeGridResult = buildFeedbackResult('error', 'product.sizeGrid');
                    });
                })
                .finally(function () {
                    $timeout(function () {
                        $scope.sizeGridLoading = false;
                    });
                });
        }

        function checkDisabledState(expectedRole) {
            return !$scope.productCardDto.smFamily.universeCode || !userSettings.hasRole(expectedRole);
        }

        function isAdmin() {
            return userSettings.hasRole('ROLE_ADMIN');
        }


        function submit() {
            modelService.cleanDimensions($scope.productNature, $scope.model);
            $uibModalInstance.close($scope.model);
        }

        $scope.changeDefaultSignKitArticleId = function (selectedArticle) {
            if (selectedArticle.balisage) {
                $scope.model.defaultSignKitArticleId = selectedArticle.code;
            } else {
                $scope.model.defaultSignKitArticleId = null;
            }
            _($scope.model.items).each(function (article) {
                article.balisage = (article.code === $scope.model.defaultSignKitArticleId);
            });

        };


        $scope.updateWeight = function (article) {
            article.weightInputField = article.weightInput;
        };

        function initWeight(article) {
            if (!article.weightInput) {
                article.weightInput = article.weightReceived;
            }
        }

        $scope.showWeight = function (article) {
            if (!article.weightReceived) {
                return 'product.article.dimensions.weight.neverReceived';
            }
            if (!article.weightInputField) {
                return 'product.article.dimensions.weight.received';
            }
            return 'product.article.dimensions.weight.received.modify';
        };

        $scope.dimensionIsDisabled = true;
        $scope.$watch('model.metadatas.paceGridSize', function (paceGridSize) {
            var hasRight = !$scope.checkDisabledState('ROLE_CUD');
            var isAdministrator = $scope.isAdmin;
            $scope.dimensionIsDisabled = !hasRight || (!isAdministrator && paceGridSize);
        });

    }

})();
